// Icerik cevirisi arka planda kosuyor; bu dosya durumu rozete cevirir.
//
// Bilesenden ayri tutuldu cunku ilginc olan kisim goruntu degil kural:
// "ne zaman takilmis sayilir", "ne zaman yeniden denenebilir".

// Dyno yeniden baslarsa arka plandaki is oluyor ve kayit 'pending'/'running'
// halinde kaliyor. Kuyruk altyapisi kurmak yerine belli sureden eskisi
// takilmis sayilir ve admin tek tikla yeniden tetikler — tek admin, dusuk
// hacim, kurtarma bir tik.
export const STUCK_AFTER_MS = 10 * 60 * 1000;
export const ALL_LANGS = ['en', 'de', 'es', 'fr', 'it'];

/**
 * @param {{state?: string, langs?: string[], error?: string, updatedAt?: string}} status
 * @param {number} now
 * @returns {{label: string, tone: 'ok'|'warn'|'busy'|'error'|'none', canRetry: boolean}}
 */
export function describeI18nStatus(status, now = Date.now()) {
  if (!status || !status.state) return { label: '', tone: 'none', canRetry: false };

  const done = (status.langs || []).length;
  const age = status.updatedAt ? now - new Date(status.updatedAt).getTime() : 0;

  if (status.state === 'error') {
    return { label: 'hata', tone: 'error', canRetry: true };
  }
  if (status.state === 'pending' || status.state === 'running') {
    if (age > STUCK_AFTER_MS) return { label: 'takıldı', tone: 'warn', canRetry: true };
    return { label: 'çevriliyor', tone: 'busy', canRetry: false };
  }
  if (done >= ALL_LANGS.length) {
    return { label: `${ALL_LANGS.length} dil`, tone: 'ok', canRetry: false };
  }
  return { label: `${done}/${ALL_LANGS.length} dil`, tone: 'warn', canRetry: true };
}
